import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { OverviewService } from '../overview.service';
import { SharingPanelService } from '../../../shared-service/sharing-panel-service';
import { BaseService } from '../../../shared-service/base.service';
import { SharingPanelComponent } from '../../../shared-components/sharing-panel/sharing-panel.component';
declare var $: any;

@Component({
	selector: 'app-settings-panel',
	templateUrl: './settings-panel.component.html',
	styleUrls: ['./settings-panel.component.css'],
	encapsulation: ViewEncapsulation.None
})

export class SettingPanelComponent implements OnInit, OnDestroy {

	@Input() data: object|any;
	options: object = {
		keyboard: true,
		backdrop: true,
		show: true
	}

	constructor(private os: OverviewService, private sps: SharingPanelService, public bs: BaseService) {}

	ngOnInit() {
		console.log("ngOnInit SettingPanelComponent");
		this.openModelPopup();
	}

	ngOnDestroy() {
		console.log("ngOnDestroy SettingPanelComponent");
	}

	openModelPopup() {
		$('#sharingModal').modal(this.options);
	}

	closePanel() {
		$('#sharingModal').modal('hide');
		this.sps.resetPanel();
		this.sps.sharedSuccess.next(true);
		this.sps.updateActiveWall(false);
	}

	showHideList() {		
		this.closePanel();		
    		this.sps.updateComponentObj(SharingPanelComponent, {setting: SettingPanelComponent});
		this.sps.updateActiveWall(true);
    }

    /*saveList() {
    	console.log('saveList()');
    }*/

    /*showHideList() {
		this.sps.updateComponentObj(SharingPanelComponent, { setting: SettingsComponent });
	}*/

	saveList() {
		let userIds;
		userIds = $('input[name=Users]:checked').map(function () {
			return this.id;
		}).get().join(',');

		if (userIds == '') {
			alert(this.bs.getResource('rbkey_VldtUnhdUsrMSG'));
			return false;
		} else {
			const params: object =
			{
				'UserID': this.bs.getUserAttr('UserId'),
				'CorporateID': this.bs.getUserAttr('CorporateId'),
				'SelectedUserIds': userIds,
			};
			this.os.getUnBlockedSelectedUser(params, "****").then((data) => {
				/*this.userList = data['lstUserDetails'];*/
				this.closePanel();
			}, (err) => {
				console.log(err);
			});
		}
	}
}
